import { useEffect } from 'react'

const MARGEN = 480

/**
 * Scroll continuo: llama a `cargarMas` cuando el centinela (un elemento al pie de la
 * lista) se acerca a la pantalla. Dos vías, porque ninguna es infalible por sí sola:
 * IntersectionObserver y un escucha de scroll en captura como respaldo (además revisa
 * una vez al cambiar la lista: si la tanda no llenó la pantalla, sigue sola).
 *
 * @param {{ current: HTMLElement|null }} centinelaRef
 * @param {() => void} cargarMas  debe ignorarse a sí misma si ya está cargando o no hay más
 * @param {unknown} clave  cambia cuando cambia la lista, para volver a revisar
 */
export function useScrollInfinito(centinelaRef, cargarMas, clave) {
  useEffect(() => {
    const el = centinelaRef.current
    if (!el) return undefined
    const cerca = () => el.getBoundingClientRect().top < window.innerHeight + MARGEN
    let pendiente = false
    const revisar = () => {
      if (pendiente) return
      pendiente = true
      // setTimeout y no rAF: si la pestaña no pinta, rAF no corre y la lista no avanza.
      setTimeout(() => { pendiente = false; if (cerca()) cargarMas() }, 50)
    }
    let obs
    if (typeof IntersectionObserver !== 'undefined') {
      obs = new IntersectionObserver((entradas) => { if (entradas[0].isIntersecting) cargarMas() }, { rootMargin: `${MARGEN}px 0px` })
      obs.observe(el)
    }
    window.addEventListener('scroll', revisar, { capture: true, passive: true })
    window.addEventListener('resize', revisar, { passive: true })
    revisar()
    return () => {
      obs?.disconnect()
      window.removeEventListener('scroll', revisar, { capture: true })
      window.removeEventListener('resize', revisar)
    }
  }, [centinelaRef, cargarMas, clave])
}

export default useScrollInfinito
